// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-c6ed7a06]{position:relative}.error-page img[data-v-c6ed7a06]{width:100%;height:auto;min-height:300px;object-fit:cover}.error-page .error-page-content[data-v-c6ed7a06]{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);width:520px;max-width:100%}@media(max-width: 991.98px){.error-page .text-7xl[data-v-c6ed7a06]{font-size:2.25rem;line-height:3rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
